export const sm = {
  msg:
    {
      username: 'Igoa',
      password: 'Upu fa’alilolilo/Password',
      login: 'Saini i totonu',
      changeLanguage: '',
      'lang-en': 'English',
      'lang-ms': 'Bahasa Melayu',
      submit_button_text: 'Lafo',
      enter: 'Oomi',
      en: 'English',
      ms: 'Bahasa Melayu',
      id: 'Bahasa Indonesia',
      zh: 'Chinese',
      to: 'Tonga',
      sm: 'Samoan',
      copyright: 'Lagolagoina e le Global Psytech',
      new_password: 'Password Fou',
      confirm_new_password: 'Fa’amautinoa le Password Fou',
      forgot_password_header: 'Galo le Password',
      basic_info: 'Basic Information',
      password_set: 'Set Password',
      sign_up: 'Lesitala',
      product_info: 'Oloa o loo Apalai iai',
      continue: 'Fa’aauau',
      back: 'Tua',
      cancel_reset: 'Fa’aleaogā',
      forgot_password: 'Galo le Password?',
      sign_up_message: 'e fatu ai se account',
      reset_success: 'Successfully reset your password. Please login using the new password.',
      dpa_heading: 'Maliega mo le Puipuiga o Fa’amatalaga Patinp i le Tagata',
      dpa_body1: 'Ua fa’atinoina le GFI ina ia tausia ai le teu fa’aliloliloina o fa’amatalaga e tuuina mai e ogatasi ma le Tulafono mo le Puipuia o Fa’amatalaga. Mo le tausisia o tulafono fa’atonutonu e fa’atatau i le puipuiina o fa’amatalaga, o le a matou fa’amautinoaina o fa’amaumauga/fa’amatalaga aoina mai i lenei su’ega o le a tuuina atu na’o le tagata fa’atau lea o loo matou fa’atautaia ai lenei su’ega poo le tagata ua fa’atagaina e fai ma sui filifilia a le tagata fa’atau.',
      dpa_body2: 'O fa’amaumauga/fa’amatalaga uma o le a teuina ma tuuina atu ma le talafeagai ma saogalemū, tusa pe nofo i totonu o Samoa poo fafo le tagata fa’atau.',
      dpa_body3: 'O ni isi fesoota’iga e faia fa’atatau i le fa’aaogaina o fa’amaumauga/fa’amatalaga o le a tuuina i aiaiga ma tulaga a le tagata fa’atau ma lana mataupu.',
      close: 'Tāpuni ʻa',
      reset_button: 'Lafo',
      successfully_register: 'Ua taliaina lau lesitala. Fa’amolemole saini i totonu e fa’aaoga ai lou igoa lesitala ma le password.',
      cloned_user: 'O ou togi mulimuli o le GFI o loo mafai ona fa’aaogaina pea. O le mea lea e le tatau ona toe faia ai sau su’ega o le GFI.',
      password_changed: 'Ua taliaina lau lesitala. Fa’amolemole saini i totonu e fa’aaoga ai lou igoa lesitala ma le password.',
      loading_text: 'Fa’atalitali...',
      month_label: 'Masina',
      create_registration: 'Fatu lou igoa lesitala ma le password'
    },
  error: {
    full_name_required: 'Fa’amolemole tusi lou igoa atoa e pei ona tusia ai i luga o lou ID faigaluega.',
    full_name_min: 'O le igoa atoa e tatau ona lē ititi ifo ma le 5 mata’itusi le umi.',
    full_name_max: 'O le igoa atoa e le mafai ona sili atu ma le 80 mata’itusi.',
    full_name_regex: 'O mata’itusi etaliaina ua na’o mata’itusi o le alafapeti, avanoa, ma mata’itusi fa’apitoa o loo mulimuli mai: @ ’ – ma le / .',

    id_num_required: 'Fa’amolemole tuu i totonu le numera o lau ID.',
    id_num_max: 'E le tatau ona sili atu ma le 20 mata’itusi poo numera patino ia te oe o lau ID.',
    id_num_regex: 'O mata’itusi etaliaina ua na’o mata’itusi o le alafapeti, numera, ma mata’itusi fa’apitoa o loo mulimuli mai: - ma le /',

    business_reg_required: 'Fa’amolemole tuu i totonu le numera lesitala o le pisinisi a lau kamupani / numera o le laisene o lau pisinisi.',
    business_reg_max: 'E le tatau ona sili atu ma le 20 mata’itusi le numera lesitala o le pisinisi / o le numera o le laisene pisinisi.',
    business_reg_min: 'O le numera lesitala o le pisinisi / o le numera o le laisene pisinisi e tatau ona pe tusa ma le 3 mata’itusi le umi.',
    business_reg_regex: 'O mata’itusi etaliaina ua na’o mata’itusi o le alafapeti, numera, ma mata’itusi fa’apitoa o loo mulimuli mai: - ma le /',

    company_name_required: 'Fa’amolemole tusi le igoa o lau kamupani.',
    company_name_min: 'O le igoa o le kamupani e tatau ona lē  ititi ifo ma le 5 mata’itusi le umi.',
    company_name_max: 'E le tatau ona sili atu ma le 80 mata’itusi le igoa o le kamupani.',
    company_name_regex: 'O mata’itusi etaliaina ua na’o mata’itusi o le alafapeti, avanoa, numera, ma mata’itusi fa’apitoa o loo mulimuli mai: . - & () and ’',

    business_category_required: 'Select business category',
    product_applied_required: 'Fa’amolemole filifili le oloa fa’aaitalafu o loo e apalai iai.',
    commencement_date_required: 'Please enter your company’s business commencement date.',
    facility_required: 'Please select the facilities you are applying',
    facilities_required: 'Please select the facilities you are applying.',

    amount_applied_required: 'Fa’amolemole tuu i totonu le aofa’i e te mana’o e nōnō.',
    amount_applied_maxvalue: 'E lē tatau ona sili atu ma le {0} {2} le aofa’i e faatalosagaina.',
    amount_applied_minvalue: 'E tatau ona pe tusa ma le {0} {1} tala le aofai’ga o le tupe e talosagaina.',

    tenure_required: 'Fa’amolemole tuu i totonu le taimi fuafuaina mo le totogiina o loo e apalai iai.',
    tenure_maxvalue: 'O le umi fuafuaina mo le totogiina e tatau ona le sili atu ma le {1} masina.',
    tenure_minvalue: 'O le taimi maualalo fuafuaina mo le totogiina e tatau ona pe tusa ma le {0} masina.',

    officerinchargeid_required: 'Fa’amolemole tuu i totonu le numera o le ID a le Tagata Ofisa mo Nōnōgatupe o loo faia lau mataupu.',
    officerinchargeid_invalid: 'Invalid Loan Officer ID. Please enter the correct Loan Officer ID.',
    officerinchargeid_regex: 'O mata’itusi etaliaina ua na’o mata’itusi o le alafapeti, numera, ma mata’itusi fa’apitoa o loo mulimuli mai: ! # - and @',
    officerinchargeid_min: 'E tatau ona pe tusa ma le 6 mata’itusi le umi o numera o le ID.',
    officerinchargeid_max: 'E le tatau ona sili atu ma le 15 mata’itusi o le numera o le ID.',

    username_required: 'Fa’amolemole tuu i totonu le igoa.',
    username_min: 'E tatau ona pe tusa ma le 6 mata’itusi le umi o lau igoa.',
    username_max: 'E le tatau ona 15 mata’itusi le umi o lau igoa.',
    username_regex: 'O mata’itusi etaliaina ua na’o mata’itusi o le alafapeti, numera, ma mata’itusi fa’apitoa o loo mulimuli mai: ! # - and @',
    username_duplicate: 'Ua fa’aaoga le igoa lena. Fa’amolemole tuu i totonu se isi igoa.',

    password_required: 'Fa’amolemole tuu i totonu le password.',
    password_min: 'E tatau ona pe tusa ma le 6 mata’itusi le umi o lau password.',
    password_max: 'E le tatau ona sili atu ma le 15 mata’itusi numera o lau password.',
    password_regex: 'O mata’itusi etaliaina ua na’o mata’itusi o le alafapeti, numera, ma mata’itusi fa’apitoa o loo mulimuli mai: ! # - and @',
    confirm_password_regex: 'O mata’itusi etaliaina ua na’o mata’itusi o le alafapeti, numera, ma mata’itusi fa’apitoa o loo mulimuli mai: ! # - and @',
    new_password_regex: 'O mata’itusi etaliaina ua na’o mata’itusi o le alafapeti, numera, ma mata’itusi fa’apitoa o loo mulimuli mai: ! # - and @',

    confirm_password_required: 'Toe tuu i totonu lau password mo le fa’amautinoaina.',
    confirm_password_confirmed: 'E le o tutusa lau password ma le password fa’amautinoa.',
    confirm_password_min: 'E tatau ona pe tusa ma le 6 mata’itusi le umi o lau password.',
    confirm_password_max: 'E le tatau ona sili atu ma le 15 mata’itusi numera o lau password.',

    registrationtoken_required: 'Fa’amolemole tuu i totonu le numera fa’amaonia sa tuuina atu ia te oe.',
    registrationtoken_min: 'E mana’omia le 6 o mata’itusi o lau numera faamaonia.',
    registrationtoken_max: 'E mana’omia le 6 o mata’itusi o lau numera faamaonia.',
    registrationtoken_duplicate: 'E le o sa’o le numera fa’amaonia. Fa’amolemole tuu i totonu le numera fa’amaonia sa’o.',
    registrationtoken_regex: 'Na’o mata’itusi o le alafapeti ma numera e taliaina.',

    confirm_password_placeholder: 'Toe tuu i totonu lau password.',

    error: 'E le sa’o le igoa poo le password.',
    registration_error: 'Something went wrong please try again',
    new_password_required: 'Fa’amolemole tuu i totonu lau password fou.',
    confirm_new_password_required: 'Fa’amolemole toe tuu  i totonu lau password mo le fa’amautinoaina.',
    invalid_credentials: 'E le sa’o le igoa poo le password.',

    consent_required: 'Ae le’i faia lau lesitala, e tatau ona faitau le Maliēga mo le Puipuiga o Fa’amatalaga Patino i le Tagata ma talia e ala i le fa’ailogaina o le pusa ua saunia.',

    reset_invalid: 'We are unable to find your account by the details provided.',
    new_password_min: 'E tatau ona 6 mata’itusi le umi o lau password.',
    new_password_max: 'E le tatau ona sili atu ma le 15 mata’itusi numera o lau password.',
    confirm_new_password_min: 'E tatau ona 6 mata’itusi le umi o lau password.',
    confirm_new_password_max: 'E le tatau ona sili atu ma le 15 mata’itusi numera o lau password.',
    confirm_new_password_confirmed: 'E le o tutusa lau password ma le password fa’amautinoa.',
    register_username_details_does_not_match: 'E le o tutusa le numera o lau ID Fa’aTagatanuu ma fa’amaumauga o lesitala.',
    register_username_not_found: 'Ua galo lou igoa? Fa’amolemole fa’afesoota’i se fesoasoani.',
    data_tempered: 'Unable to reset your password. Please try again later.',
    branch_required: 'Fa’amolemole filifili le LāLā.',
    drop_down_not_available: 'E le’o iai se fa’amaumauga o maua',
    repeating_user: 'Fa’amalie atu e le mafai ona faia lau lesitala.',

    id_type_required: 'Fa’amolemole filifili le ituaiga o pepa fa’amaonia mo lou ID.',
    br_type_required: 'Please select Business Registration type.'
  },
  registration: {
    full_name: 'Igoa Atoa (e tusa ai ma lou ID)',
    id_num: 'Numera Patino ia te Oe (ID)',
    business_reg: 'Lesitala o le Pisinisi/Numera o le Laisene Pisinisi',
    company_name: 'Igoa o le Kamupani',
    product_applied: 'Oloa o loo Apalai iai',
    commencement_date: 'Business Commencement Date',
    facilities: 'Facilities Applied',
    amount_applied: 'Tupe Aofa’i o loo Talosagaina (Tala)',
    tenure: 'Taimi fuafuaina mo le Totogiina (i masina)',
    business_category: 'Business Category',
    confirm_password: 'Fa’amautinoa le Password',
    verification_code: 'Numera Fa’amaonia',
    consent1: 'Sa ou faitau ma ou malamalama i le',
    consent2: 'Maliēga mo le Puipuiga o Fa’amatalaga Patino i le Tagata',
    consent3: 'ma ua ou malie i le fa’aaogaina o o’u fa’amatalaga e pei ona fa’amanino mai ai i le Maliēga.',
    cancel: 'Fa’aleaogā',
    register: 'Lesitala',
    branch: 'LāLā',
    officer: 'Numera o le ID a le Tagata Ofisa mo Nōnōgatupe',
    id_type: 'Ituaiga Numera o le ID',
    br_type: 'Business Registration Number Type (Samoan)'
  }
}
